import { noop } from 'lodash';

import { ConfirmProps } from './_partitions/Confirm/Confirm';

export const DEFAULT_CONFIRM_PROPS: ConfirmProps = {
  icon: 'lifebuoy',
  cancelText: '',
  confirmText: '',
  message: '',
  onConfirm: () => Promise.resolve(),
  dissmiss: noop,
};
